import React from 'react'
import { Popover } from '@material-ui/core'
import { Icon } from '@iconify/react'
import { colors } from 'src/components/app-ui'
import useStyles from './styles'

export const CREATE_OPTIONS = [
  {
    value: 'scratch',
    title: 'Create from scratch',
    menuDesc: 'Start with a blank course in the editor.',
    cardDesc:
      'Start with a blank course and add sections and pages in the editor.',
    meta: 'Editor',
    icon: 'tabler:pencil',
    iconBg: colors.hover,
    iconColor: colors.navy,
  },
  {
    value: 'ai',
    title: 'AI Course Builder',
    menuDesc: 'Describe a topic or upload a document. Uses AI credits.',
    cardDesc:
      'Describe a topic or upload a document. AI drafts the sections and pages for you to edit.',
    meta: 'Uses AI credits',
    icon: 'tabler:sparkles',
    iconBg: colors.primarySoft,
    iconColor: colors.primary,
  },
]

/** "Create from scratch" / "AI Course Builder" dropdown under a trigger. */
const CreateCourseMenu = ({ anchorEl, align = 'left', onClose, onSelect }) => {
  const classes = useStyles()

  return (
    <Popover
      open={Boolean(anchorEl)}
      anchorEl={anchorEl}
      onClose={onClose}
      anchorOrigin={{ vertical: 'bottom', horizontal: align }}
      transformOrigin={{ vertical: 'top', horizontal: align }}
      PaperProps={{ className: classes.menu, elevation: 0 }}
    >
      {CREATE_OPTIONS.map(option => (
        <button
          key={option.value}
          type="button"
          className={classes.menuItem}
          onClick={() => onSelect(option.value)}
        >
          <span
            className={classes.menuIcon}
            style={{ background: option.iconBg, color: option.iconColor }}
          >
            <Icon icon={option.icon} width={18} height={18} />
          </span>
          <span className={classes.menuText}>
            <span className={classes.menuTitle}>{option.title}</span>
            <span className={classes.menuDesc}>{option.menuDesc}</span>
          </span>
        </button>
      ))}
    </Popover>
  )
}

export default CreateCourseMenu
